import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=39a49ce3&scoped=true"
import script from "./UploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=39a49ce3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a49ce3",
  null
  
)

export default component.exports